<template>
  <div class="supplies-select">
    <div class="supplies-select__container">
      <label
        for="supply"
        class="supplies-select__label"
      >
        Adicionar:
      </label>
      <div
        v-click-outside="handleClickOutside"
        class="supplies-select__input-wrapper"
      >
        <div class="supplies-select__input-container">
          <input
            v-model="inputText"
            class="supplies-select__input"
            placeholder="Digite a descrição ou nome do insumo que deseja adicionar..."
            type="text"
            name="supply"
            @focus="handleFocus()"
            @keyup="textSearch"
          />
          <div
            v-if="loading"
            class="supplies-select__input-loading"
          >
            <spinner class="xsmall" />
          </div>
        </div>
        <div
          v-if="showItems"
          class="supplies-select__items"
        >
          <div
            v-for="(item, index) in items"
            :key="index"
            class="supplies-select__item"
            @click="handleClick(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="supplies-select__selected">
      <div
        v-if="supplies.length > 0"
        class="supplies-select__results"
      >
        <div
          v-for="(item, index) in supplies"
          :key="index"
          class="supplies-select__results-item"
        >
          <div class="supplies-select__results-head">
            <div class="supplies-select__results-item-name">
              {{ item.name }}
            </div>
            <div class="supplies-select__results-item-delete">
              <div
                id="delete"
                class="status-icon icon-delete-alt"
                @click="handleDelete(index)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </div>
          <div class="supplies-select__justification input-forms">
            <div>
              <card-form :collapsed="true">
                <div
                  slot="expanded"
                  class="form-container"
                >
                  <md-layout
                    :md-gutter="24"
                    md-flex="100"
                  >
                    <md-layout
                      md-flex="80"
                      md-flex-medium="80"
                    >
                      <md-input-container
                        :name="'reason' + index"
                        :class="{
                          'md-input-placeholder md-advanced-select': true,
                          'md-has-value': supplies[index].reasonSelected,
                          'md-input-invalid': errors.has('reason' + index),
                        }"
                      >
                        <label>Motivo do pedido</label>
                        <advanced-select
                          v-model="supplies[index].reasonSelected"
                          v-validate="'required'"
                          :name="'reason' + index"
                          :options="reasons"
                        />
                        <span class="md-error">Obrigatório</span>
                      </md-input-container>
                    </md-layout>
                    <md-layout
                      md-flex="20"
                      md-flex-medium="20"
                      class="supplies-select__quantity"
                    >
                      <md-input-container
                        :name="'quantity' + index"
                        :class="{ 'md-input-invalid': errors.has('quantity' + index) }"
                      >
                        <label>Quantidade</label>
                        <md-input
                          v-model="supplies[index].quantity"
                          v-validate="'required|numeric'"
                          v-mask="'##########'"
                          :name="'quantity' + index"
                          placeholder="Quantidade"
                          maxlength="9"
                          type="text"
                          data-vv-validate-on="none"
                        />
                        <span class="md-error">Obrigatório</span>
                      </md-input-container>
                    </md-layout>

                    <!-- justify reason -->
                    <md-layout
                      v-if="checkReason(supplies[index])"
                      md-flex="100"
                      md-flex-medium="100"
                      class="supplies-select__reason"
                    >
                      <md-input-container
                        id="patientName"
                        :class="{ 'md-input-invalid': errors.has('justification' + index) }"
                      >
                        <label>Justificativa*</label>
                        <md-input
                          v-model="supplies[index].justification"
                          v-validate="'required'"
                          data-vv-validate-on="none"
                          :name="'justification' + index"
                          maxlength="160"
                          type="text"
                          title
                          placeholder="Justificativa*"
                        />
                        <span class="md-error">Obrigatório</span>
                      </md-input-container>
                    </md-layout>
                  </md-layout>
                </div>
              </card-form>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="supplies-select__empty"
      >
        Você ainda não adicionou insumos nesse pedido.
      </div>
    </div>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm';
import { clickOutside } from '@/utils/directives';
import { mask } from 'vue-the-mask';
import notify from '@/api/notification';
import AdvancedSelect from '../common/AdvancedSelect.vue';
import SupplyService from '@/api/supply';
import Spinner from '../common/Spinner.vue';

export default {
  name: 'SuppliesInput',
  components: { AdvancedSelect, CardForm, Spinner },
  directives: {
    clickOutside,
    mask,
  },
  props: {
    supplies: {
      default: () => [],
      type: Array,
    },
  },
  data: () => ({
    timer: undefined,
    loading: false,
    inputText: '',
    itemSelected: false,
    reasons: [],
    items: [],
  }),
  computed: {
    showItems() {
      if (this.inputText.length > 2 && !this.itemSelected && this.items.length > 0) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    SupplyService.getReasons().then(response => {
      let reasons = response.data;
      reasons = reasons.map(reason => {
        reason.label = reason.name;
        reason.value = reason.name;
        return reason;
      });
      this.reasons = reasons;
    });
  },
  methods: {
    handleDelete(index) {
      this.supplies.splice(index, 1);
    },
    checkReason(item) {
      if (item.reasonSelected) {
        return item.reasonSelected.hasJustification;
      }
      return false;
    },
    textSearch() {
      this.items = [];
      if (this.inputText.length > 2) {
        this.loading = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          SupplyService.getSupplyByText(this.inputText)
            .then(response => {
              this.items = response.data;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }, 600);
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('validData', true);
          this.$emit('update-list', this.supplies);
        } else {
          this.$emit('validData', false);
        }
      });
    },
    handleClick(item) {
      let supplies = this.supplies;
      this.inputText = '';
      this.itemSelected = true;
      let checkDuplicated = supplies.filter(x => x.sapCode === item.sapCode);
      if (!checkDuplicated.length > 0) {
        supplies = supplies.concat(item);
        this.$emit('update-list', supplies.reverse());
      } else {
        notify({
          title: 'AVISO: ',
          message: 'Não foi possível incluir o insumo. Este insumo já foi adicionado ao pedido',
        });
      }
    },
    handleFocus() {
      this.itemSelected = false;
    },
    handleClickOutside() {
      this.itemSelected = true;
    },
  },
};
</script>

<style lang="scss">
.supplies-select {
  .loader.xsmall {
    width: 16px;
    height: 16px;
    border-width: 2px;
  }
  &__justification {
    width: 100%;
  }
  &__input-container {
    position: relative;
  }
  &__input-loading {
    position: absolute;
    top: 0;
    right: 5px;
  }
  &__container {
    display: flex;
    margin-bottom: 20px;
  }
  &__reason {
    margin-top: 10px;
  }
  &__label {
    text-transform: uppercase;
    color: #727272;
    font-size: 13px;
    font-weight: 600;
    width: 75px;
  }
  &__input-wrapper {
    width: calc(100% - 75px);
    position: relative;
  }
  &__input {
    outline: none;
    width: 100%;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 0 0px 5px 20px;
    background-image: url('/static/images/icon-search-new.svg');
    background-repeat: no-repeat;
    background-position: 3px 2px;

    &::placeholder {
      color: #5a5a5a;
      font-family: 'Exo 2', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
    }
  }
  &__items {
    display: block;
    background-color: #fff;
    border-radius: 0 0 5px 5px;
    padding: 4px 0;
    position: absolute;
    width: 100%;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.14);
    z-index: 99;
    max-height: 295px;
    overflow-x: auto;
  }
  &__item {
    padding: 8px 25px;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }
  &__empty {
    height: 165px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999999;
    font-size: 16px;
  }
  &__results-item {
    background-image: url('/static/images/supplies-card-detail.png');
    background-position: 0 0;
    background-repeat: no-repeat;
    background-color: #fff;
    border-radius: 6px;
    padding: 22px 20px;
    margin-top: 10px;
  }
  &__results-head {
    display: flex;
    justify-content: space-between;
  }
  &__results-item-name {
    font-weight: 600;
    font-size: 13.3px;
    line-height: 16px;
    text-transform: uppercase;
    color: #464646;
  }
  &__results-item-delete {
    position: relative;
    top: -6px;
  }
  &__quantity {
    .md-has-value {
      &:before {
        content: 'Un';
        position: absolute;
        right: 8px;
        bottom: 4px;
        color: #818181;
        font-size: 13.3px;
      }
    }
  }
  .md-input-container.md-theme-default {
    margin: -10px 0 5px 0;
  }

  .md-input-container {
    input {
      color: #5a5a5a !important;

      &::placeholder {
        color: #999999;
      }
    }

    label {
      color: #999999 !important;
    }
  }
}
.multiselect__single {
  color: #5a5a5a;
}
</style>
